import React from 'react'

import { Logo } from 'components'
import { MainNav } from 'components'
import { MetaNav } from 'components'
import styles from './Header.scss';

const Header = (props) => {
  return (
    <div className={styles.header}>
      <Logo/>
      <MainNav/>
      <MetaNav/>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/organisms/Header/index.js